import { render, staticRenderFns } from "./EtransactElectricityWallet.vue?vue&type=template&id=807788e2&scoped=true"
import script from "./EtransactElectricityWallet.vue?vue&type=script&lang=js"
export * from "./EtransactElectricityWallet.vue?vue&type=script&lang=js"
import style0 from "./EtransactElectricityWallet.vue?vue&type=style&index=0&id=807788e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807788e2",
  null
  
)

export default component.exports